import { render } from "./PostListItem.vue?vue&type=template&id=bc4ed9a8&scoped=true"
import script from "./PostListItem.vue?vue&type=script&lang=js"
export * from "./PostListItem.vue?vue&type=script&lang=js"

import "./PostListItem.vue?vue&type=style&index=0&id=bc4ed9a8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc4ed9a8"]])

export default __exports__